export default __webpack_public_path__ + "static/assets/fonts/bf2d0ff73eef7cdc4a77482dd4b91acb.woff2";